import { Controller } from "@hotwired/stimulus";
import { isInputFilled, toggleClass } from "../../utils/misc";
import { roundToTwoDecimals } from "../../utils/number_utils";
import { handlePartialInvoiceGenerationFromQuoteResponse } from "../../sales_invoices/utils";

export default class extends Controller {
  static values = {
    grossTotal: Number,
    modalId: String,
  };

  static targets = [
    "percentTypeRadioButton",
    "instalmentRawValue",
    "instalmentComputedGrossAmount",
    "instalmentComputedGrossAmountText",
  ];

  onFormSubmit(event) {
    const payload = event.detail[0];

    handlePartialInvoiceGenerationFromQuoteResponse(payload, this.modalIdValue);
  }

  computeInstalmentGrossAmount() {
    this.instalmentComputedGrossAmountTarget.value = this._instalmentGrossAmount(this.grossTotalValue);

    toggleClass(this.instalmentComputedGrossAmountTextTarget, "hidden", this._isPercentType());
  }

  _instalmentGrossAmount(quoteAmount) {
    if (!isInputFilled(this.instalmentRawValueTarget)) {
      return 0;
    }

    const instalmentRawValue = this.instalmentRawValueTarget.value;
    let instalmentComputedGrossAmount = instalmentRawValue;

    if (this._isPercentType()) {
      instalmentComputedGrossAmount = this._percentValue(quoteAmount, instalmentRawValue);
    }

    return instalmentComputedGrossAmount;
  }

  _isPercentType() {
    return this.percentTypeRadioButtonTarget.checked === true;
  }

  _percentValue(quoteAmount, inputValue) {
    return roundToTwoDecimals(quoteAmount * (parseFloat(inputValue) / 100));
  }
}
